module.exports = __webpack_public_path__ + "img/logo_no_text.70fc4c52.svg";